<template>
  <div class="personal_profile">
    <step-status :step="$route.meta.step" class="mt55"></step-status>

    <h4>
      <span>Personal Profile</span>
    </h4>
    <p class='profile_text'>Please complete the following personal profile to assist us in completing your American Academy account.</p>
    <div class="personal_top">
      <ul class="personal_list">
        <li v-for="(item, index) in per_opt" :key="index">
          <router-link :to='item.to' replace active-class='active' tag='div' v-if='_boardingStep.reachStep.includes(item.step)' :class='{complete: _boardingStep.doneStep.includes(item.step)}'>
            <span :class="item.addClass"></span>
            <br>
            <p class="step_text">{{item.names}}</p>
            <em class="icon"></em>
            <b></b>
          </router-link>
          <div v-else :class='{complete: _boardingStep.doneStep.includes(item.step)}'>
            <span :class="item.addClass"></span>
            <br>
            <p class="step_text">{{item.names}}</p>
            <em class="icon"></em>
            <b></b>
          </div>
        </li>
      </ul>
    </div>
    <div class="basic_information">
      <router-view></router-view>
    </div>
    <div class="download">
      <ul class="clearfix">
        <li>
          <ac></ac>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import ac from '@common/ac'

export default {
  props: {},
  data() {
    return {
      isMac: false,
      isWindows: false
    }
  },
  methods: {},
  computed: {
    ...mapState(['per_opt', 'init_state']),
    ...mapGetters(['_boardingStep'])
  },
  components: {
    ac
  }
}
</script>

<style lang='less' scoped>
.personal_profile {
  width: 1000px;
  margin: 0 auto;
  & > h4 {
    padding-top: 46px;
    height: 24px;
    margin-bottom: 18px;
    span {
      font-size: 24px;
      font-weight: bold;
      color: #febf00;
      float: left;
      margin-right: 26px;
    }
  }
  .profile_text {
    font-size: 15px;
    margin-bottom: 40px;
  }
  .personal_top {
    height: 116px;
    border-bottom: 1px solid #e6e6e6;
    font-size: 14px;
    .personal_list {
      float: left;
      color: #1e1e1e;
      margin-left: -20px;

      li {
        float: left;
        margin-left: 20px;

        & > div {
          float: left;
          width: 182px;
          height: 70px;
          text-align: center;
          padding-top: 14px;
          border: 1px solid #ccc;
          border-radius: 10px;
          cursor: default;
          position: relative;
          span {
            width: 28px;
            height: 29px;
            display: inline-block;
            background: url('~@img/step.png') 0 -51px no-repeat;
            margin-bottom: 5px;
            &.step1 {
              background-position: 0 -51px;
            }
            &.step2 {
              background-position: -52px -51px;
            }
            &.step3 {
              background-position: -103px -51px;
            }
            &.step4 {
              background-position: -152px -51px;
            }
            &.step5 {
              background-position: -202px -51px;
            }
            &.step6 {
              width: 6px;
              height: 10px;
              float: right;
              background-position: -129px -94px;
              margin-top: 23px;
              margin-right: 35px;
            }
          }
          .step_text {
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: #1e1e1e;
          }
          .icon {
            position: absolute;
            display: none;
            width: 20px;
            height: 11px;
            left: 50%;
            bottom: -32px;
            margin-left: -10px;
            background: red url('~@img/step.png') -122px -113px
              no-repeat;
          }
          .step_text {
            font-size: 15px;
            color: #999;
            padding-top: 4px;
          }
          &.active {
            border-color: #fcc800;
            cursor: pointer;
            span {
              &.step1 {
                background-position: 0 0;
              }
              &.step2 {
                background-position: -52px 0;
              }
              &.step3 {
                background-position: -103px 0;
              }
              &.step4 {
                background-position: -152px 0;
              }
              &.step5 {
                background-position: -202px 0;
              }
              &.step6 {
                background-position: -111px -94px;
              }
            }
            .step_text {
              color: #fcc800;
              font-weight: bold;
            }
            .icon {
              display: block;
            }
          }
          &.complete {
            b {
              width: 32px;
              height: 32px;
              position: absolute;
              right: -1px;
              bottom: -1px;
              background: url('~@img/step.png') -148px -92px
                no-repeat;
            }
          }
        }
      }
    }
  }
  .basic_information {
    padding-top: 30px;
    margin-bottom: 100px;
  }
  .download {
    position: fixed;
    top: 166px;
    right: 80px;
    z-index: 99;
    & > ul {
      width: 75px;
      li {
        float: left;
        margin-top: 6px;
        background-color: #fff;
        border-radius: 5px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// personal_profile.vue?203c6b86